import type { UnifiedContext } from '../context';
import { handleBuyLink } from './buyLink';
import { handleDevices } from './devices';
import { handleDiscount } from './discount';
import { handleHide } from './hide';
import { handlePrice } from './price';
import { handleSubscription } from './subscription';
import { handleTrialLink } from './trialLink';

export type AttributeHandler = (el: HTMLElement, ctx: UnifiedContext) => void | Promise<void>;

// Dispatch known attribute handlers. Order matters for conflicts; keep hide last.
const handlers: AttributeHandler[] = [
  handleDevices,
  handleSubscription,
  handleBuyLink,
  handlePrice,
  handleDiscount,
  handleHide,
  handleTrialLink
  // further handlers (devices, subscription, links) will be pushed here
];

export const renderAttributes = async (el: HTMLElement, ctx: UnifiedContext) => {
  for (const h of handlers) {
    await h(el, ctx);
  }
};
